var map = {
	"./android-icon-144x144.png": 143,
	"./android-icon-192x192.png": 144,
	"./android-icon-36x36.png": 145,
	"./android-icon-48x48.png": 146,
	"./android-icon-72x72.png": 147,
	"./android-icon-96x96.png": 148,
	"./apple-icon-114x114.png": 149,
	"./apple-icon-120x120.png": 150,
	"./apple-icon-144x144.png": 151,
	"./apple-icon-152x152.png": 152,
	"./apple-icon-180x180.png": 153,
	"./apple-icon-57x57.png": 154,
	"./apple-icon-60x60.png": 155,
	"./apple-icon-72x72.png": 156,
	"./apple-icon-76x76.png": 157,
	"./apple-icon-precomposed.png": 158,
	"./apple-icon.png": 159,
	"./browserconfig.xml": 160,
	"./favicon-16x16.png": 161,
	"./favicon-32x32.png": 162,
	"./favicon-96x96.png": 163,
	"./favicon.ico": 164,
	"./manifest": 72,
	"./manifest.json": 72,
	"./ms-icon-144x144.png": 165,
	"./ms-icon-150x150.png": 166,
	"./ms-icon-310x310.png": 167,
	"./ms-icon-70x70.png": 168
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 115;



/** WEBPACK FOOTER **
 ** ./app/static/images/icons /^/.//
 **/